import { TextOrHTML } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { useMemo, isValidElement } from "react";
import type { Locale } from "../../../types";
import { ambles } from "../../../content/ambles";
import { getAmble } from "./getAmble";

export type AmbleElement = HTMLDivElement;

export type AmbleProps = {
  className?: string;
  amble?: string;
  ambleName?: string;
  site: string;
  locale: Locale;
};

/**
 * Amble component for questionnaires.
 * Renders direct HTML string content via the amble prop and/or registry lookup by ambleName.
 * Registry entries can be HTML strings or React elements.
 */
export const Amble = ({
  className,
  amble,
  ambleName,
  site,
  locale,
}: AmbleProps) => {
  const content = useMemo(() => {
    if (ambleName) {
      const lookedUp = getAmble({ ambleName, site, locale, ambles });
      if (lookedUp) return lookedUp;
    }
    if (amble) return amble;
    return undefined;
  }, [amble, ambleName, site, locale]);

  if (!content) {
    return null;
  }

  if (isValidElement(content)) {
    return content;
  }

  return (
    <TextOrHTML
      htmlClassName={classNames("mobius-amble", className)}
      text={content}
      textWrapper
    />
  );
};

Amble.displayName = "Amble";
